import { Box, FormHelperText } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export default function CDatePicker({
  placeholder,
  value,
  onChange,
  minDate,
  maxDate,
  label,
  style,
  size,
  error,
  disabled,
  boxStyle,
}) {
  return (
    <Box sx={{ ...boxStyle }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopDatePicker
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          inputFormat="dd-MM-yyyy"
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled ? disabled : false}
          label={label}
          renderInput={(params) => (
            <TextField size={size || "large"} style={style} {...params} />
          )}
        />
      </LocalizationProvider>
      <FormHelperText sx={{ color: "red", ml: "12px" }}>
        {error && error}
      </FormHelperText>
    </Box>
  );
}
